import React, { useState } from 'react'
import { Col, Row, Button, ButtonGroup } from 'react-bootstrap'
import moment from 'moment'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'

function FiltroFecha (props) {
  const { filtroTiempo, setFiltroTiempo } = props
  const [fechaDesde, setFechaDesde] = useState(moment(new Date()).format('DD-MM-YYYY'))
  const [fechaHasta, setFechaHasta] = useState(moment(new Date()).format('DD-MM-YYYY'))

  const actualizarFechas = (fechaD, fechaH) => {
    const fechaDesde = moment(new Date(fechaD)).format('YYYY-MM-DD')
    const fechaHasta = fechaH ? moment(new Date(fechaH)).format('YYYY-MM-DD') : fechaDesde
    console.log('fechas ', fechaDesde, fechaHasta)
  }

  const actualizarSemana = () => {
    const fechaHasta = moment(new Date()).format('YYYY-MM-DD')
    const fechaDesde = moment(fechaHasta).subtract(7, 'days').format('YYYY-MM-DD')
    setFechaDesde(fechaDesde)
    setFechaHasta(fechaHasta)
    setFiltroTiempo('semana')
  }

  console.log('fecha desde y hasta ', fechaDesde, fechaHasta)
  return (
    <Row className='mb-4 align-items-center' style={{ padding: '0 15px' }}>
      <Col md={4} sm={12} />
      <Col md={8} sm={12} className='d-flex justify-content-end align-items-center flex-wrap gap-2'>
        <ButtonGroup aria-label='Filtro temporal'>
          <Button
            variant={filtroTiempo === 'hoy' ? 'primary' : 'outline-light'}
            onClick={() => {
              setFiltroTiempo('hoy')
              // setFechaEspecifica(moment().format('DD-MM-YYYY'))
            }}
          >
                        Hoy
          </Button>
          <Button
            variant={filtroTiempo === 'semana' ? 'primary' : 'outline-light'}
            onClick={actualizarSemana}
          >
                        Semana completa
          </Button>
        </ButtonGroup>

        <div className='ml-2 ms-2' style={{ minWidth: '160px' }}>
          <DatePicker
            selectRange
            locale='es'
            onDateChange={actualizarFechas}
            titulo=' '
            fechaDesde={fechaDesde}
            fechaHasta={fechaHasta}
            disabledFuture
            value='fechaMonitoreo'
            colorText='#ffffff'
          />
        </div>
      </Col>
    </Row>
  )
}

export default FiltroFecha
